(() => {
  const aggregateGroups = {"skrivbord": {"title": "Skrivbord", "urls": ["/collections/skrivbord", "/collections/elektriskt-hoj-och-sankbart-bord-1", "/collections/manuellt-hoj-och-sankbart-bord", "/collections/enstationsskrivbord", "/collections/bankskrivbord", "/collections/chefsskrivbord", "/collections/skrivbordssystem", "/collections/skrivbordstillbehor"]}, "kontorsstolar": {"title": "Stolar", "urls": ["/collections/kontorsstolar", "/collections/konferensstolar-1", "/collections/hoga-stolar-kontor", "/collections/matstolar-kontor", "/collections/stapelbara-stolar-kontor", "/collections/bankar-kontor", "/collections/fotpallar-kontor"]}, "loungemobler-reception-typer": {"title": "Bord & lounge", "urls": ["/collections/loungemobler-reception", "/collections/konferensbord-lounge", "/collections/matbord", "/collections/hoga-bord", "/collections/modulbord", "/collections/fallbara-bord-lounge"]}, "forvaring-skap-typer": {"title": "Förvaring", "urls": ["/collections/forvaring-skap", "/collections/bokhyllor", "/collections/chefsskap", "/collections/garderober", "/collections/skap-med-glasdorrar", "/collections/forvaringsskap", "/collections/kapphangare"]}, "akustik-typer": {"title": "Akustik & belysning", "urls": ["/collections/akustik", "/collections/akustikbas", "/collections/motesbas", "/collections/akustikpaneler", "/collections/bordsskarmar", "/collections/fristaende-skarmar", "/collections/belysning"]}, "stolar-typer": {"title": "Restaurangstolar", "urls": ["/collections/restaurangstolar", "/collections/trastolar", "/collections/kladda-stolar", "/collections/karmstolar", "/collections/metallstolar", "/collections/plaststolar", "/collections/cafe-bistro"]}, "restaurangbord": {"title": "Restaurangbord", "urls": ["/collections/restaurangbord", "/collections/bordsskivor", "/collections/bordsunderstall"]}, "uteservering": {"title": "Uteservering", "urls": ["/collections/uteservering", "/collections/parisstolar", "/collections/flatade-utestolar", "/collections/aluminiumstolar", "/collections/tra-teakstolar", "/collections/oltradgardsstolar", "/collections/utomhus-bordsskivor", "/collections/utomhus-bordsstativ"]}, "beredning": {"title": "Beredning", "urls": ["/collections/beredning", "/collections/bullrivare-bullrundare", "/collections/blandningsmaskiner", "/collections/degmaskiner", "/collections/gronsaksskarare", "/collections/knivslipar", "/collections/kottkvarnar", "/collections/kottbandsag", "/collections/mixers-blenders", "/collections/potatisskalare", "/collections/skarmaskiner", "/collections/snabbhack-mixer", "/collections/stavmixers", "/collections/vakuummaskiner", "/collections/not-och-chokladkvarnar", "/collections/mos-hummusmaskiner"]}, "buffe": {"title": "Buffé", "urls": ["/collections/buffe", "/collections/drop-in", "/collections/kall-buffe", "/collections/varm-buffe"]}, "grillar": {"title": "Grillar", "urls": ["/collections/grillar", "/collections/elgrillar", "/collections/gasgrill", "/collections/kolgrill", "/collections/korvgrillar", "/collections/klamgrill", "/collections/kycklinggrill", "/collections/lavastensgrillar", "/collections/salamander", "/collections/vattengrillar"]}, "varmhallning": {"title": "Varmhållning", "urls": ["/collections/varmhallning", "/collections/chafing-dish", "/collections/kokgrytor", "/collections/pastakokare", "/collections/pommesvarmare", "/collections/riskokare", "/collections/soppkittel", "/collections/vattenbad", "/collections/varmbuffe", "/collections/varmemonter", "/collections/spishallar-varmeplattor", "/collections/varmehall", "/collections/korv-brod-och-mosvarmeri", "/collections/hamburgervarmeri", "/collections/varmeskap-bankettvagn"]}, "varmkok": {"title": "Varmkök", "urls": ["/collections/varmkok", "/collections/brodrost-brodgrillar", "/collections/fritoser", "/collections/stekbord", "/collections/stekhallar", "/collections/spisar", "/collections/ugnar", "/collections/sous-vide"]}, "cateringutrustning": {"title": "Cateringutrustning", "urls": ["/collections/cateringutrustning", "/collections/thermoboxar"]}, "diskteknik": {"title": "Diskteknik", "urls": ["/collections/diskteknik", "/collections/inmatningsbank", "/collections/utmatningsbank", "/collections/diskmaskiner", "/collections/forspolningsdusch"]}, "churrosmaskiner": {"title": "Churrosmaskiner", "urls": ["/collections/churrosmaskiner", "/collections/churros-fyllningsmaskin", "/collections/churros-fritoser"]}, "konferensbord-1": {"title": "Konferens & bankett", "urls": ["/collections/konferensbord-1", "/collections/bankettbord", "/collections/konferensstolar", "/collections/bankettstol", "/collections/cateringstolar"]}, "event-massa": {"title": "Event & mässa", "urls": ["/collections/event-massa", "/collections/flaggor", "/collections/beachflaggor", "/collections/banderoller", "/collections/eventtalt", "/collections/uppblasbart"]}, "klader": {"title": "Profilkläder", "urls": ["/collections/klader", "/collections/t-shirts", "/collections/piketrojor", "/collections/sweatshirts", "/collections/jackor-vastar", "/collections/arbetsklader", "/collections/kepsar", "/collections/profilklader-ovrigt", "/collections/hoodies", "/collections/skjortor-blusar", "/collections/byxor-shorts", "/collections/barnklader", "/collections/fleece", "/collections/sport-funktionsklader", "/collections/foretagsklader", "/collections/kladaccessoarer", "/collections/handdukar-badrockar", "/collections/underklader"]}, "giveaways": {"title": "Giveaways", "urls": ["/collections/giveaways", "/collections/skrivinstrument", "/collections/dryckesflaskor-muggar", "/collections/vaskor", "/collections/ryggsackar", "/collections/nyckelringar", "/collections/teknik", "/collections/paraplyer-vader"]}, "present-premium": {"title": "Present & fritid", "urls": ["/collections/present-premium", "/collections/koksprodukter", "/collections/sport-fritid", "/collections/hem-fritid", "/collections/verktyg-tillbehor", "/collections/kontorsprodukter", "/collections/barn-lek", "/collections/hallbart"]}};
  const media = window.matchMedia('(min-width: 990px)');
  function configure(root) {
    root.querySelectorAll('.fr-category-menu').forEach(menu => {
      menu.open = media.matches;
      if (!menu.dataset.configured) {
        menu.dataset.configured = 'true';
        menu.addEventListener('toggle', () => {
          if (media.matches && !menu.open) menu.open = true;
        });
      }
    });
    root.querySelectorAll('.fr-catalog-layout').forEach(initialize);
  }
  function initialize(layout) {
    if (layout.dataset.interactive) return;
    layout.dataset.interactive = 'true';
    const nav = layout.querySelector('.fr-category-menu');
    const content = layout.querySelector('.fr-catalog-content');
    if (!nav || !content) return;
    const chairPage = layout.dataset.catalogKind !== 'office';
    const heading = document.createElement('h2');
    heading.className = 'fr-catalog-current';
    heading.tabIndex = -1;
    const firstHeading = chairPage ? content.querySelector('h2') : null;
    if (firstHeading) firstHeading.remove();
    const results = document.createElement('div');
    results.className = 'fr-catalog-results';
    const help = content.querySelector('.fr-catalog-help');
    while (content.firstChild && content.firstChild !== help) results.append(content.firstChild);
    const status = document.createElement('p');
    status.className = 'fr-catalog-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'button fr-catalog-retry';
    retry.hidden = true;
    retry.textContent = layout.dataset.retry;
    content.prepend(heading, status, retry, results);
    let current = new URL(layout.dataset.initialCollection, window.location.origin);
    let selected = nav.querySelector('.is-active');
    let controller;
    let debounce;
    let pending;
    heading.textContent = selected.dataset.categoryLabel || selected.querySelector('span:nth-child(2)')?.textContent.trim() || selected.textContent.trim();
    const initialMarkup = results.innerHTML;
    const initialURL = current.href;
    function mark(link) {
      nav.querySelectorAll('.fr-category-link').forEach(item => {
        item.classList.toggle('is-active', item === link);
        if (item === link) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
    }
    const pageURL = new URL(window.location.href);
    const aggregateKey = pageURL.searchParams.get('fr_group') || pageURL.pathname.split('/').filter(Boolean).pop();
    const aggregateGroup = pageURL.hash === '#kategori' ? undefined : aggregateGroups[aggregateKey];
    if (pageURL.searchParams.has('fr_group')) {
      pageURL.searchParams.delete('fr_group');
      window.history.replaceState(window.history.state, '', pageURL.pathname + pageURL.search + pageURL.hash);
    }
    if (!aggregateGroup) {
      nav.querySelectorAll('.fr-category-link').forEach((link, index) => {
        if (index > 0 && new URL(link.href).pathname === current.pathname) link.remove();
      });
    }
    const aggregateLabels = JSON.parse(layout.querySelector('.fr-group-labels')?.textContent || '{}');
    let aggregateCards;
    async function getAggregateCards(signal) {
      if (aggregateCards) return aggregateCards;
      const cards = new Map();
      let cursor = 0;
      async function worker() {
        while (cursor < aggregateGroup.urls.length) {
          const path = aggregateGroup.urls[cursor++];
          let url = new URL(path, window.location.origin);
          const visited = new Set();
          while (url) {
            if (visited.has(url.href)) throw new Error('Repeated catalogue page');
            visited.add(url.href);
            const response = await fetch(url, { signal, credentials: 'same-origin' });
            if (response.status === 404) break;
            if (!response.ok) throw new Error('Category unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const source = html.querySelector('#ProductGridContainer');
            if (!source) throw new Error('Category grid unavailable');
            source.querySelectorAll('.product-grid > .grid__item').forEach(item => {
              const card = item.querySelector('[data-fr-product-id]');
              if (card && !cards.has(card.dataset.frProductId)) cards.set(card.dataset.frProductId, item);
            });
            const next = source.querySelector('.pagination__item--prev');
            if (next) {
              const candidate = new URL(next.getAttribute('href'), url);
              if (candidate.origin !== window.location.origin || candidate.pathname !== path) throw new Error('Invalid pagination');
              url = candidate;
            } else url = null;
          }
        }
      }
      await Promise.all(Array.from({ length: Math.min(4, aggregateGroup.urls.length) }, worker));
      if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
      aggregateCards = [...cards.values()];
      return aggregateCards;
    }
    async function renderAggregate(url, signal) {
      const cards = await getAggregateCards(signal);
      const sort = url.searchParams.get('sort_by') || 'original';
      const available = url.searchParams.get('fr_available') || 'all';
      const minRaw = url.searchParams.get('fr_minprice');
      const maxRaw = url.searchParams.get('fr_maxprice');
      const minPrice = minRaw ? Number(minRaw.replace(',', '.')) * 100 : null;
      const maxPrice = maxRaw ? Number(maxRaw.replace(',', '.')) * 100 : null;
      let ordered = cards.filter(item => {
        const data = item.querySelector('[data-fr-product-id]').dataset;
        if (minPrice !== null && Number.isFinite(minPrice) && Number(data.frProductPrice) < minPrice) return false;
        if (maxPrice !== null && Number.isFinite(maxPrice) && Number(data.frProductPrice) > maxPrice) return false;
        return available === 'all' || (data.frProductAvailable === 'true') === (available === 'yes');
      });
      const data = item => item.querySelector('[data-fr-product-id]').dataset;
      if (sort === 'price-ascending') ordered.sort((a, b) => Number(data(a).frProductPrice) - Number(data(b).frProductPrice));
      if (sort === 'price-descending') ordered.sort((a, b) => Number(data(b).frProductPrice) - Number(data(a).frProductPrice));
      if (sort === 'title-ascending') ordered.sort((a, b) => data(a).frProductTitle.localeCompare(data(b).frProductTitle, document.documentElement.lang));
      const pageSize = 36;
      const pages = Math.max(1, Math.ceil(ordered.length / pageSize));
      const page = Math.min(pages, Math.max(1, Number(url.searchParams.get('page')) || 1));
      const wrapper = document.createElement('div');
      const controls = document.createElement('form');
      controls.className = 'fr-group-controls';
      function addSelect(labelText, name, choices, selectedValue) {
        const label = document.createElement('label');
        label.append(document.createTextNode(labelText));
        const select = document.createElement('select');
        select.name = name;
        choices.forEach(([value, title]) => select.add(new Option(title, value, false, selectedValue === value)));
        label.append(select);
        controls.append(label);
      }
      addSelect(aggregateLabels.sort, 'sort_by', [['original', aggregateLabels.default], ['price-ascending', aggregateLabels.low], ['price-descending', aggregateLabels.high], ['title-ascending', aggregateLabels.name]], sort);
      addSelect(aggregateLabels.availability, 'fr_available', [['all', aggregateLabels.all], ['yes', aggregateLabels.available], ['no', aggregateLabels.unavailable]], available);
      [['fr_minprice', aggregateLabels.minPrice, minRaw], ['fr_maxprice', aggregateLabels.maxPrice, maxRaw]].forEach(([name, title, value]) => {
        const label = document.createElement('label');
        label.append(document.createTextNode(title));
        const input = document.createElement('input');
        input.type = 'number';
        input.name = name;
        input.min = '0';
        input.step = 'any';
        input.inputMode = 'decimal';
        input.value = value || '';
        label.append(input);
        controls.append(label);
      });
      function updateAggregateControls() {
        const next = new URL(current);
        next.searchParams.delete('page');
        new FormData(controls).forEach((value, key) => next.searchParams.set(key, value));
        load(next, nav.querySelector('.fr-category-link'));
      }
      controls.addEventListener('change', updateAggregateControls);
      controls.addEventListener('submit', event => { event.preventDefault(); updateAggregateControls(); });
      const apply = document.createElement('button');
      apply.type = 'submit';
      apply.className = 'button button--secondary';
      apply.textContent = aggregateLabels.apply;
      controls.append(apply);
      const count = document.createElement('p');
      count.className = 'fr-group-count';
      count.textContent = ordered.length + ' ' + aggregateLabels.products;
      const grid = document.createElement('ul');
      grid.className = 'product-grid grid grid--2-col-tablet-down grid--3-col-desktop';
      grid.setAttribute('role', 'list');
      ordered.slice((page - 1) * pageSize, page * pageSize).forEach(item => {
        const clone = item.cloneNode(true);
        clone.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in', 'scroll-trigger--offscreen');
        grid.append(clone);
      });
      wrapper.append(controls, count, grid);
      if (!ordered.length) {
        const empty = document.createElement('p');
        empty.textContent = aggregateLabels.empty;
        wrapper.append(empty);
      }
      if (pages > 1) {
        const pagination = document.createElement('nav');
        pagination.className = 'fr-group-pagination pagination-wrapper';
        pagination.setAttribute('aria-label', aggregateLabels.pagination);
        const label = document.createElement('span');
        label.textContent = page + ' / ' + pages;
        function addPage(number, text) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'button button--secondary';
          button.textContent = text;
          button.addEventListener('click', () => {
            const next = new URL(current);
            next.searchParams.set('page', number);
            load(next, nav.querySelector('.fr-category-link'), true);
          });
          pagination.append(button);
        }
        if (page > 1) addPage(page - 1, aggregateLabels.previous);
        pagination.append(label);
        if (page < pages) addPage(page + 1, aggregateLabels.next);
        wrapper.append(pagination);
      }
      return wrapper;
    }

    async function load(url, link = selected, focus = false) {
      controller?.abort();
      controller = new AbortController();
      const signal = controller.signal;
      pending = { url, link, focus };
      results.setAttribute('aria-busy', 'true');
      status.textContent = layout.dataset.loading;
      retry.hidden = true;
      try {
        let markup;
        if (aggregateGroup && link === nav.querySelector('.fr-category-link')) {
          const aggregate = await renderAggregate(url, signal);
          markup = aggregate.outerHTML;
          results.replaceChildren(aggregate);
        } else if (chairPage && url.href === initialURL) {
          markup = initialMarkup;
        } else {
          const response = await fetch(url, { signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Collection unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = chairPage ? html.querySelector('#ProductGridContainer') : html.querySelector('collection-component');
          if (!source) throw new Error('Missing product grid');
          markup = source.outerHTML;
        }
        if (signal.aborted) return;
        if (!(aggregateGroup && link === nav.querySelector('.fr-category-link'))) results.innerHTML = markup;
        results.querySelectorAll('.scroll-trigger').forEach(el => el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in'));
        current = url;
        selected = link;
        mark(link);
        const label = aggregateGroup && link === nav.querySelector('.fr-category-link') ? aggregateGroup.title : link.dataset.categoryLabel || link.querySelector('span:nth-child(2)')?.textContent.trim() || link.textContent.trim();
        heading.textContent = label;
        status.textContent = `${layout.dataset.updated} ${label}`;
        if (!media.matches) nav.open = false;
        if (focus) heading.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError') {
          status.textContent = layout.dataset.error;
          retry.hidden = false;
        }
      } finally {
        if (!signal.aborted) results.removeAttribute('aria-busy');
      }
    }
    if (aggregateGroup) {
      heading.textContent = aggregateGroup.title;
      selected.dataset.categoryLabel = aggregateGroup.title;
      const selectedTitle = selected.querySelector('span:nth-child(2)');
      if (selectedTitle) selectedTitle.textContent = aggregateGroup.title;
      const pageHeading = document.querySelector('#MainContent h1');
      if (pageHeading) pageHeading.textContent = aggregateGroup.title;
      const pageDescription = pageHeading?.parentElement?.querySelector(':scope > p:not(.fr-catalog-eyebrow)');
      if (pageDescription && aggregateLabels.description) pageDescription.textContent = aggregateLabels.description;
      load(current);
    }
    retry.addEventListener('click', () => { if (pending) load(pending.url, pending.link, pending.focus); });
    layout.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a');
      if (!link) return;
      if (link.matches('.fr-category-link')) {
        const destination = new URL(link.href, window.location.origin);
        const fullPageCategories = /^\/collections\/(?:bordsskivor(?:-i-[a-z0-9-]+|-med-hpl-pa-spanskiva)?|restaurangbord(?:-1)?|bordsunderstall|bordsstativ-(?:soffbord-lounge|matbord|barbord-stabord))\/?$/;
        if (destination.origin === window.location.origin && fullPageCategories.test(destination.pathname)) return;
        event.preventDefault();
        clearTimeout(debounce);
        const url = new URL(link === nav.querySelector('.fr-category-link') ? layout.dataset.initialCollection : link.href, window.location.origin);
        load(url, link, true);
      } else if (results.contains(link) && (link.closest('.pagination-wrapper') || link.closest('facet-remove'))) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const url = new URL(link.href);
        url.pathname = current.pathname;
        load(url, selected, true);
      }
    }, true);
    function applyFilters(event) {
      if (!results.contains(event.target) || !event.target.closest('facet-filters-form')) return;
      event.stopImmediatePropagation();
      const form = event.target.closest('form');
      if (!form) return;
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        const url = new URL(current);
        [...url.searchParams.keys()].forEach(key => {
          if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') url.searchParams.delete(key);
        });
        const forms = form.id === 'FacetFiltersFormMobile' ? [form] : [...results.querySelectorAll('facet-filters-form form')].filter(item => item.id !== 'FacetFiltersFormMobile');
        forms.forEach(item => new FormData(item).forEach((value, key) => {
          if (String(value).trim()) url.searchParams.append(key, value);
        }));
        load(url);
      }, 300);
    }
    layout.addEventListener('input', applyFilters, true);
    layout.addEventListener('submit', event => {
      if (!results.contains(event.target) || !event.target.closest('facet-filters-form')) return;
      event.preventDefault();
      applyFilters(event);
    }, true);
  }
  configure(document);
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a');
    if (!link || !link.closest('.header__inline-menu,.menu-drawer')) return;
    const target = new URL(link.href);
    const source = new URL(window.location.href);
    if (target.origin === source.origin && target.pathname === source.pathname && target.hash !== source.hash &&
        (target.hash === '#kategori' || source.hash === '#kategori')) {
      event.preventDefault();
      window.history.pushState(window.history.state, '', target.href);
      window.location.reload();
    }
  }, true);
  media.addEventListener('change', () => configure(document));
  document.addEventListener('shopify:section:load', event => configure(event.target));
})();
